module.exports = __webpack_public_path__ + "img/KM.72d912ef.svg";